function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import regeneratorRuntime from "regenerator-runtime";
// tslint:disable:no-console
import { analytics } from "@kaggle/protos";
import Cookie from "js-cookie";
import { v4 as uuidv4 } from "uuid";
/** The logic to encode the queues events and flush them to relay. */ export var prodFlushEventQueue = function() {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(queue, info, token) {
        var batch, body, response;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(queue.length === 0)) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return", 200);
                case 2:
                    _ctx.prev = 2;
                    batch = makeEventBatch(queue, info, token);
                    body = analytics.kaggle.analytics.SaveClientAnalyticsRequest.encode(batch).finish();
                    _ctx.next = 7;
                    return fetch("https://analytics.kaggle.io/record-events", {
                        method: "POST",
                        body: body
                    });
                case 7:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.status);
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](2);
                    // tslint:disable-next-line:no-console
                    console.warn("An issue occurred flushing the events queue.", _ctx.t0);
                    return _ctx.abrupt("return", 500);
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                2,
                11
            ]
        ]);
    }));
    return function prodFlushEventQueue(queue, info, token) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Returns a batch of events with additional metadata.
 *
 * @param queue Array of events to be logged.
 * @param sessionInfo Metadata associated with session used to augment
 *    payload containing batch of sessions.
 * @param token Token used for authorization by analytics service.
 */ function makeEventBatch(queue, param, token) {
    var userId = param.userId, pageview = param.pageview;
    return analytics.kaggle.analytics.SaveClientAnalyticsRequest.create({
        url: document.location ? document.location.pathname : "",
        userId: userId,
        // We no longer support kaggleAnalyticsUserHash, this should be removed
        // from the report structure in the future.
        kauh: "",
        session: getAnalyticsSessionCookie(),
        timeZoneOffsetMinutes: new Date().getTimezoneOffset(),
        referrer: document.referrer,
        token: token,
        performanceTier: 1,
        competitionsTier: 1,
        kernelsTier: 1,
        discussionTier: 1,
        windowWidthPixels: window.innerWidth,
        windowHeightPixels: window.innerHeight,
        screenWidthPixels: window.screen.width,
        screenHeightPixels: window.screen.height,
        events: queue,
        pageview: pageview,
        urlQueryString: window.location.search
    });
}
/** Returns unique session identifier stored in browser's Cookies. */ function getAnalyticsSessionCookie() {
    var existingResult = getSessionCookie();
    if (existingResult) {
        return existingResult;
    }
    var newResult = uuidv4();
    setSessionCookie(newResult);
    return newResult;
}
// getSessionCookie returns the session ID if it is present in the user's browser cookies, and
// null otherwise.
function getSessionCookie() {
    return Cookie.get("ka_sessionid");
}
function setSessionCookie(value) {
    // Following go/cookie-guidlines, we use a 6-month expiry for this cookie without an explicit opt-in.
    var seconds = 1000;
    var minutes = 60 * seconds;
    var hours = 60 * minutes;
    var days = 24 * hours;
    var months = 30.4 * days;
    var expiryDate = new Date();
    expiryDate.setTime(expiryDate.getTime() + 6 * months);
    document.cookie = "ka_sessionid=".concat(value, "; expires=").concat(expiryDate.toUTCString(), "; path=/");
}
/** Writes events in queue to console. */ export var consoleFlushEventQueue = function(queue, info, _token) {
    if (queue.length > 0) {
        // Print analytics messages in a collapsed group.
        console.groupCollapsed("@kaggle/analytics", "".concat(queue.length, " events"));
        // Print session information.
        console.table([
            info
        ]);
        // Print queue.
        console.table(queue);
        // End group.
        console.groupEnd();
    }
    return Promise.resolve(200);
};
